import billingMock from '../mock/billing.json';
import type { BillingResponse } from './types';

const MOCK_DELAY_MS = 200;

const delay = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

// In-memory копия мок-данных. При подключении бэка тело функции заменяется на HTTP-запрос.
let store: BillingResponse = billingMock as BillingResponse;

/**
 * Возвращает сводку биллинга текущего месяца.
 * Мок-реализация без бэкенда.
 */
export const fetchBilling = async (): Promise<BillingResponse> => {
  await delay(MOCK_DELAY_MS);
  return store;
};
